export class SecurityUserRoleVerificationModel {
}
export default class AzureActiveDirectoryRole extends SecurityUserRoleVerificationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
